var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasLoading && ( _vm.$route.meta.isAdd || _vm.model ))?_c('div',{staticClass:"client"},[_c('base-form',{staticClass:"client__form display--grid"},[_c('base-card',{staticClass:"card--identification",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                    "+_vm._s(_vm.$t("global.identification"))+"\n                ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"client__body card--identification__body display--grid"},[_c('base-field',{staticClass:"client__body__number",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.associateNumber') },
                            input: {
                                component: 'InputBasic',
                                id: 'number',
                                name: 'number',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.number,
                                browserAutocomplete: 'off',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.number,
                                fileValidation: 'numberInt',
                                errors: [{
                                    type: 'integer', warning: _vm.$t('error.integer')
                                }],
                                errorOnSubmit: {
                                    show: _vm.errors.api.number ? true : false,
                                    messages: _vm.errors.api.number
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-field',{staticClass:"client__body__type",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.associateType') },
                            input: {
                                component: 'InputAutocomplete',
                                name: 'type',
                                id: 'type',
                                type: 'text',
                                value: ("" + (_vm.types.api.id)),
                                targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                placeholder: _vm.$t('global.selectAnOption'),
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.type,
                                dynamicData: {
                                    data: _vm.types.drop,
                                    apiValue: { value: ("" + (_vm.types.api.id)), label: _vm.types.api.name }
                                },
                                noListener: true
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-button',{staticClass:"client__body__delete-associate",domProps:{"innerHTML":_vm._s(_vm.$t("global.deleteAssociate"))},nativeOn:{"click":function($event){$event.preventDefault();return _vm.modals.deleteAssociate.actions.open( 'deleteAssociate' )}}})],1)]},proxy:true}],null,false,4065676460)}),_c('div',{staticClass:"client__form__left-column"},[_c('base-card',{staticClass:"card--personal-information",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                        "+_vm._s(_vm.$t("global.personalInformation"))+"\n                    ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"client__body display--grid"},[_c('base-field',{staticClass:"client__body__honorific-prefix",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.honorificPrefix') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'prefix',
                                    name: 'prefix',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.prefix,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.prefix,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.prefix ? true : false,
                                        messages: _vm.errors.api.prefix
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__name",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.name') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'name',
                                    name: 'name',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.name,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.name,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.name ? true : false,
                                        messages: _vm.errors.api.name
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__simple-name",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.simpleName') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'simpleName',
                                    name: 'simpleName',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.simpleName,
                                    browserAutocomplete: 'off',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.simpleName,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.simpleName ? true : false,
                                        messages: _vm.errors.api.simpleName
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__address",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.address') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'address',
                                    name: 'address',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.address,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.address,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.address ? true : false,
                                        messages: _vm.errors.api.address
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__zip-code",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.zipCode') },
                                input: {
                                    component: 'InputBasic',
                                    name: 'zipCode',
                                    id: 'zipCode',
                                    type: 'text',
                                    mask: _vm.isForeignRegion ? '' : '####-###',
                                    value: _vm.model.zipCode,
                                    class: 'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.zipCode,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.zipCode ? true : false,
                                        messages: _vm.errors.api.zipCode
                                    },
                                    placeholder: 'Ex: 0000-000',
                                    noListener: true
                                },
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__region",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.region') },
                                input: {
                                    component: 'InputAutocomplete',
                                    name: 'region',
                                    id: 'region',
                                    type: 'text',
                                    value: _vm.model.region,
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: _vm.$t('global.selectAnOption'),
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.region,
                                    dynamicData: {
                                        data: _vm.regions.drop,
                                        apiValue: { value: _vm.model.region, label: _vm.model.region }
                                    },
                                    noListener: true
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__country",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.country') },
                                input: {
                                    component: 'InputAutocomplete',
                                    name: 'country',
                                    id: 'country',
                                    type: 'text',
                                    value: ("" + (_vm.countries.api.id)),
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: _vm.$t('global.selectAnOption'),
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.country,
                                    dynamicData: {
                                        data: _vm.countries.drop,
                                        apiValue: { value: ("" + (_vm.countries.api.id)), label: _vm.countries.api.name }
                                    },
                                    noListener: true
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}})],1)]},proxy:true}],null,false,1799445144)}),_c('base-card',{staticClass:"card--payment-information",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                        "+_vm._s(_vm.$t("global.paymentInformation"))+"\n                    ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"display--grid"},[_c('base-field',{staticClass:"client__body__nif",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.nif') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'nif',
                                    name: 'nif',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.nif,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.nif,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.nif ? true : false,
                                        messages: _vm.errors.api.nif
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__payment-method",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.paymentMethod') },
                                input: {
                                    component: 'InputAutocomplete',
                                    name: 'paymentMethod',
                                    id: 'paymentMethod',
                                    type: 'text',
                                    value: _vm.model.paymentMethod,
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: _vm.$t('global.selectAnOption'),
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.paymentMethod,
                                    dynamicData: {
                                        data: _vm.paymentMethods.drop,
                                        apiValue: { value: _vm.model.paymentMethod, label: _vm.model.paymentMethod }
                                    },
                                    noListener: true
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}})],1)]},proxy:true}],null,false,2178319572)}),(!_vm.$route.meta.isAdd)?_c('base-card',{staticClass:"card--quotas",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                        "+_vm._s(_vm.$t("global.payedQuotas"))+"\n                    ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"display--grid"},[_c('div',{staticClass:"table--quotas"},[_c('div',{staticClass:"table--quotas__header display--flex"},[_c('div',{staticClass:"table--quotas__header__year capitalize"},[_vm._v(_vm._s(_vm.$t('global.year')))]),_c('div',{staticClass:"table--quotas__header__value capitalize"},[_vm._v(_vm._s(_vm.$t('global.value')))]),_c('div',{staticClass:"table--quotas__header__invoice capitalize"},[_vm._v(_vm._s(_vm.$t('global.invoice')))]),_c('div',{staticClass:"table--quotas__header__date capitalize"},[_vm._v(_vm._s(_vm.$t('global.date')))]),_c('div',{staticClass:"table--quotas__header__payed capitalize"},[_vm._v(_vm._s(_vm.$t('global.payed')))])]),_c('div',{staticClass:"table--quotas__body"},_vm._l((_vm.model.fees),function(fee,index){return _c('div',{key:("fee-" + index),staticClass:"table--quotas__body__row display--flex"},[_c('div',{staticClass:"table--quotas__body__row__year"},[_vm._v(_vm._s(fee.year || '---'))]),_c('div',{staticClass:"table--quotas__body__row__value"},[_vm._v(_vm._s(fee.value || '---'))]),_c('div',{staticClass:"table--quotas__body__row__invoice"},[_c('base-field',{staticClass:"client__body__invoice-number",attrs:{"settings":{
                                                label: { class: 'field__label--hide' },
                                                input: {
                                                    component: 'InputBasic',
                                                    id: ("invoiceNumber-" + (fee.id)),
                                                    name: ("invoiceNumber-" + (fee.id)),
                                                    type: 'text',
                                                    class: 'field__input--default typography--default color--default',
                                                    value: ( fee.invoiceNumber ) ? fee.invoiceNumber.toString() : '',
                                                    placeholder: _vm.$t('global.invoiceNumber'),
                                                    browserAutocomplete: 'off',
                                                    isRequired: false,
                                                    isMissing: _vm.errors.missing[("invoiceNumber-" + (fee.id))],
                                                    errorOnSubmit: {
                                                        show: _vm.errors.api[("invoiceNumber-" + (fee.id))] ? true : false,
                                                        messages: _vm.errors.api[("invoiceNumber-" + (fee.id))]
                                                    }
                                                },
                                                isEdition: _vm.isEdition,
                                                reset: _vm.reset,
                                                allowFilling: true
                                            }}})],1),_c('div',{staticClass:"table--quotas__body__row__date"},[_vm._v(_vm._s(fee.paymentDate || '---'))]),_c('div',{staticClass:"table--quotas__body__row__payed"},[_c('base-field',{staticClass:"client__body__invoice-number",attrs:{"settings":{
                                                input: {
                                                    component: 'InputCheckbox',
                                                    id: ("payed-" + (fee.id)),
                                                    name: ("payed-" + (fee.id)),
                                                    type: 'checkbox',
                                                    class: 'field__input--checkbox',
                                                    value: fee.paymentDate !== null,
                                                    browserAutocomplete: 'off',
                                                    isRequired: false,
                                                    isMissing: _vm.errors.missing[("payed-" + (fee.id))],
                                                    errorOnSubmit: {
                                                        show: _vm.errors.api[("payed-" + (fee.id))] ? true : false,
                                                        messages: _vm.errors.api[("payed-" + (fee.id))]
                                                    }
                                                },
                                                isEdition: _vm.isEdition,
                                                reset: _vm.reset,
                                                allowFilling: true
                                            }}})],1)])}),0)])])]},proxy:true}],null,false,3291020811)}):_vm._e()],1),_c('div',{staticClass:"client__form__right-column display--grid"},[_c('base-card',{staticClass:"card--professional-information",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                        "+_vm._s(_vm.$t("global.professionalInformation"))+"\n                    ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"display--grid"},[_c('base-field',{staticClass:"client__body__profession",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.profession') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'profession',
                                    name: 'profession',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.profession,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.profession,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.profession ? true : false,
                                        messages: _vm.errors.api.profession
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__role",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.professionalPosition') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'role',
                                    name: 'role',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.role,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.role,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.role ? true : false,
                                        messages: _vm.errors.api.role
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__organization",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.organization') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'organization',
                                    name: 'organization',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.organization,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.organization,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.organization ? true : false,
                                        messages: _vm.errors.api.organization
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}})],1)]},proxy:true}],null,false,1081990886)}),_c('base-card',{staticClass:"card--contact-information",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                        "+_vm._s(_vm.$t("global.contactInformation"))+"\n                    ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"client__body display--grid"},[_c('base-field',{staticClass:"client__body__email",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.email') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'email',
                                    name: 'email',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.email,
                                    browserAutocomplete: 'email',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.email,
                                    fileValidation: 'basicEmail',
                                    errors: [{
                                        type: 'email', warning: _vm.$t('error.email')
                                    }],
                                    errorOnSubmit: {
                                        show: _vm.errors.api.email ? true : false,
                                        messages: _vm.errors.api.email
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__telephone",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.telephone') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'secondaryPhone',
                                    name: 'secondaryPhone',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.secondaryPhone,
                                    browserAutocomplete: 'secondaryPhone',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.secondaryPhone,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.secondaryPhone ? true : false,
                                        messages: _vm.errors.api.secondaryPhone
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__mobile-phone",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.mobilePhone') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'primaryPhone',
                                    name: 'primaryPhone',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.primaryPhone,
                                    browserAutocomplete: 'primaryPhone',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.primaryPhone,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.primaryPhone ? true : false,
                                        messages: _vm.errors.api.primaryPhone
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"client__body__fax",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.fax') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'fax',
                                    name: 'fax',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.fax,
                                    browserAutocomplete: 'fax',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.fax,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.fax ? true : false,
                                        messages: _vm.errors.api.fax
                                    }
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}})],1)]},proxy:true}],null,false,3656219369)}),_c('base-card',{staticClass:"card--other-informations",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('span',{staticClass:"capitalize display--block"},[_vm._v("\n                        "+_vm._s(_vm.$t("global.otherInformations"))+"\n                    ")])]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"display--grid"},[_c('base-field',{staticClass:"client__body__admission-date",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.admittedOn') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'admissionDate',
                                    id: 'admissionDate',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: _vm.model.admissionDate,
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.admissionDate,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.admissionDate ? true : false,
                                        messages: _vm.errors.api.admissionDate
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling
                            }}}),_c('base-field',{staticClass:"client__body__readmission-date",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.readmittedOn') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'readmissionDate',
                                    id: 'readmissionDate',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: _vm.model.readmissionDate,
                                    browserAutocomplete: 'off',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.readmissionDate,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.readmissionDate ? true : false,
                                        messages: _vm.errors.api.readmissionDate
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling
                            }}}),_c('base-field',{staticClass:"client__body__leaving-date",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.leavingOn') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'leavingDate',
                                    id: 'leavingDate',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: _vm.model.leavingDate,
                                    browserAutocomplete: 'off',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.leavingDate,
                                    errorOnSubmit: {
                                        show: _vm.errors.api.leavingDate ? true : false,
                                        messages: _vm.errors.api.leavingDate
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling
                            }}}),_c('base-field',{staticClass:"client__body__leaving-reason",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.leavingReason') },
                                input: {
                                    component: 'InputAutocomplete',
                                    name: 'leavingReason',
                                    id: 'leavingReason',
                                    type: 'text',
                                    value: _vm.model.leavingReason,
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: _vm.$t('global.selectAnOption'),
                                    dynamicData: {
                                        data: _vm.leavingReasons.drop,
                                        apiValue: { value: _vm.model.leavingReason, label: _vm.model.leavingReason }
                                    },
                                    noListener: true
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: true
                            }}}),_c('base-field',{class:'client__body__observations',attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.observations') },
                                input: {
                                    component: 'Textarea',
                                    name: 'observations',
                                    id: 'observations',
                                    class: 'client__body__observations__field typography--default color--default',
                                    value: _vm.model.observations || '',
                                    placeholder: _vm.$t('global.observations'),
                                    disableClass: 'client__body__observations__field client__body__observations__field--disable display--block'
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling
                            }}})],1)]},proxy:true}],null,false,4041234865)}),_c('div',{staticClass:"client__body__actions display--grid"},[(_vm.getters.payloadHaveKeys)?_c('submission-handler',[_c('base-button',{staticClass:"client__body__actions__save background--blue color--white display--block",attrs:{"type":"submit"},domProps:{"innerHTML":_vm._s(_vm.$t('global.save'))}})],1):_vm._e(),(_vm.getters.payloadHaveKeys)?_c('base-button',{staticClass:"client__body__actions__cancel background--transparent color--blue",domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":_vm.cancelSubmission}}):_vm._e()],1)],1)],1),(_vm.modals.deleteAssociate.show)?_c('modal',{key:_vm.modals.deleteAssociate.show,attrs:{"form":{
            class: 'modal__confirmation--delete-associate'
        },"customSettings":{
            position: 'center',
            button: {
                label: 'remove',
                type: 'button',
                action: function () { return _vm.modals.deleteAssociate.actions.submit(); }
            }
        }},on:{"close":function($event){return _vm.modals.deleteAssociate.actions.close( 'deleteAssociate' )}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"modal__confirmation--delete-associate__header"},[_vm._v(_vm._s(_vm.$t('global.deleteAssociate')))])]},proxy:true},{key:"modal__body__confirm",fn:function(){return [_c('span',{staticClass:"modal__confirmation--delete-associate__info display--block capitalize"},[_vm._v("\n                "+_vm._s(_vm.$t('global.areYouSureYouWantTo') + _vm.$t('warning.deleteThisAssociate') + ' ?')+"\n            ")])]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"modal__content__button--negative background--transparent border--grey",domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":function($event){$event.preventDefault();return _vm.modals.deleteAssociate.actions.close( 'deleteAssociate' )}}})]},proxy:true}],null,false,1328911927)}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }